import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfigService } from 'src/app/shared/config.service';

@Component({
  selector: 'app-case-result',
  templateUrl: './case-result.component.html',
  styleUrls: ['./case-result.component.scss']
})
export class CaseResultComponent implements OnInit {

  caseResult;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private configService: ConfigService
  ) { }

  ngOnInit() {
    this.caseResult = this.configService.caseresult;
  }

  gotoCollectAnswer(){
    this.router.navigate(['../collect'], { relativeTo: this.route });
  }
}
